module.exports = __webpack_public_path__ + "img/background orange.40d25fa7.jpg";